import { createContext } from 'react';
// import { useStateManager } from '../hooks/useStateManager';

const defaultState: any = [];

const SpvContext = createContext(defaultState);

export default SpvContext;
